import * as React from 'react';
import { useMemo } from 'react';
import { useAppState } from '../core/redux/hooks';

import tbcLogo from '../assets/logo_tbc.gif';
import zfLogo from '../assets/logo_zf.png';
import hrdqLogo from '../assets/logo_hrdq.gif';
import talentSmartLogo from '../assets/logo_talentsmart.png';


type Props = {
  className?: string;
}

const LogoBox = (props: Props) => {
  const config = useAppState(state => state.config);
  const system = (config?.system || '').toLowerCase();
  const logo   = useMemo (
    () => system === 'zf'
            ? zfLogo
            : system === 'hrdq'
              ? hrdqLogo
              : system === 'talentsmart'
                ? talentSmartLogo
                : tbcLogo // always default to TBC
    ,
    [system],
  );
  
  return (
    <img className={props.className} src={logo} alt={system} />
  )
};

export default LogoBox;
